//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  qrcodejumpadd,
  qrcodejumpdelete,
  qrcodejumpdownload,
} from '@/api/miniProgramManagement.js';
export default {
  data() {
    return {
      protocol: '1',
      cases: '1',
      qcCode: '',
      test: '1',
      occupy: '',
      page: '',
      testLink: [''],

      // domain:''
    };
  },
  computed: {
    domain() {
      if (this.protocol === '1' && this.cases === '1') {
        return 'https://';
      }
      if (this.protocol === '1' && this.cases === '2') {
        return 'HTTPS://';
      }
      if (this.protocol === '2' && this.cases === '1') {
        return 'http://';
      }
      if (this.protocol === '2' && this.cases === '2') {
        return 'HTTP://';
      }

      return '';
    },
  },
  created() {
    const data = JSON.parse(localStorage.getItem('qc'));
    if (data && this.$route.query.type === 'edit') {
      if (data.prefix.startsWith('http')) {
        this.protocol = '2';
        this.cases = '1';
      }
      if (data.prefix.startsWith('https')) {
        this.protocol = '1';
        this.cases = '1';
      }
      if (data.prefix.startsWith('HTTP')) {
        this.protocol = '2';
        this.cases = '2';
      }
      if (data.prefix.startsWith('HTTPS')) {
        this.protocol = '1';
        this.cases = '2';
      }
      const reg = /(?<=(http|https):\/\/)(.*)/gi;
      this.qcCode = data.prefix.match(reg)[0] || ''; // 二维码规则
      this.test = `${data.open_version}`; // 测试范围， 开发 体验 正式版
      this.page = data.path; // 小程序功能页面
      this.occupy = `${data.permit_sub_rule}`; // 前缀占用规则
      this.testLink = data.debug_url.map((item) => {
        return item.match(reg)[0]; // 测试链接
      });
    }
  },
  methods: {
    // 下载检验文件
    handleDownLoad() {
      qrcodejumpdownload({
        appid: this.$route.query.appid,
        path: '/cgi-bin/wxopen/qrcodejumpdownload',
        body: '{}',
      }).then((data) => {
        console.log(data);
        const res = JSON.parse(data?.body || '{}');
        const eleLink = document.createElement('a');
        // 设置a标签 download 属性，以及文件名
        eleLink.download = res.file_name;
        // a标签不显示
        eleLink.style.display = 'none';
        // 获取字符内容，转为blob地址
        const blob = new Blob([res.file_content]);
        // blob地址转为URL
        eleLink.href = URL.createObjectURL(blob);
        // a标签添加到body
        document.body.appendChild(eleLink);
        // 触发a标签点击事件，触发下载
        eleLink.click();
        // a标签从body移除
        document.body.removeChild(eleLink);
      });
    },
    // 删除二维码规则
    handleDel() {
      qrcodejumpdelete({
        appid: this.$route.query.appid,
        path: '/cgi-bin/wxopen/qrcodejumpdelete',
        body: JSON.stringify({
          prefix: this.qcCode === '' ? '' : this.domain + this.qcCode,
        }),
      })
        .then(() => {
          this.$message.success('删除成功');
          this.$router.go(-1);
        })
        .catch(() => {
          this.$message.error('删除失败');
        });
    },
    // 新增或修改二维码规则
    handleSave() {
      let testLink = [];
      if (this.testLink.length > 0) {
        testLink = this.testLink.map((item) => {
          if (item === '') {
            return item;
          }
          return this.domain + item;
        });
      }
      const reqTestLink = testLink.filter((item) => item !== '');
      if (this.$route.query.type === 'add') {
        const query = {
          prefix: this.qcCode === '' ? '' : this.domain + this.qcCode,
          permit_sub_rule: this.occupy,
          path: this.page,
          open_version: this.test,
          debug_url: reqTestLink,
          is_edit: 0,
        };
        console.log(query);
        qrcodejumpadd({
          appid: this.$route.query.appid,
          path: '/cgi-bin/wxopen/qrcodejumpadd',
          body: JSON.stringify(query),
        }).then((res) => {
          console.log(res);
          this.$message.success('添加成功');
          // this.$router.go(-1);
        });
      } else {
        // let testLink = [];
        // if (this.testLink.length > 0) {
        //   testLink = this.testLink.map((item) => {
        //     return this.domain + item;
        //   });
        // }
        const query = {
          _appid: this.$route.query.appid,
          prefix: this.qcCode === '' ? '' : this.domain + this.qcCode,
          permit_sub_rule: this.occupy,
          path: this.page,
          open_version: this.test,
          debug_url: reqTestLink,
          is_edit: 1,
        };
        qrcodejumpadd(query).then((res) => {
          console.log(res);
          this.$message.success('修改成功成功');
          this.$router.go(-1);
        });
      }
    },
    handleAddTxtLink() {
      this.testLink.push('');
    },
    handleRemove(val) {
      this.testLink.splice(val, 1);
    },
    handleCancel() {
      this.$router.go(-1);
    },
  },
};
